import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../Formik'
import { TextareaOutlineField } from '../../../../../../Textarea'
import {
  LISTING_EDIT_TITLE_FIELD_MAX_LENGTH,
  LISTING_EDIT_TITLE_FIELD_MIN_ROWS,
  LISTING_EDIT_TITLE_FIELD_NAME,
  QA_NAME_LISTING_EDIT_TITLE_FIELD,
} from '../ListingEditTitleModal.constants'

function ListingEditTitleModalFields(props) {
  const { t } = useTranslation()

  const titleRef = useRef(null)

  useEffect(() => {
    titleRef.current?.focus()
  }, [])

  return (
    <FormikField
      {...props}
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      elementRef={titleRef}
      getErrorProps={getFormikFormFieldErrorProps}
      label={t('RentalPortal.ListingProfileTitleLabelKey')}
      maxLength={LISTING_EDIT_TITLE_FIELD_MAX_LENGTH}
      minRows={LISTING_EDIT_TITLE_FIELD_MIN_ROWS}
      name={LISTING_EDIT_TITLE_FIELD_NAME}
      placeholder={t('RentalPortal.ListingProfileTitlePlaceholderKey')}
      qaName={QA_NAME_LISTING_EDIT_TITLE_FIELD}
    />
  )
}

export default ListingEditTitleModalFields
